import config from "src/config";
import { SYS4010_R01Dto } from 'src/containers/mes/SYS/SYS4010_R01/Dto_SYS4010_R01';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { SYS4010_R01Filter } from "./Store_SYS4010_R01";

const baseUrl = `${config.apiUrl}/SYS4010_R01`;

export const getSYS4010_R01List = async (option: string, params: Partial<SYS4010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`

	return await getData<ResponseDto<SYS4010_R01Dto[]>>(url, {
		params: {
			...params,
			listLength
		}
	});
}

export const getSYS4010_R01AllCount = async (params: Partial<SYS4010_R01Filter>) => {
	const url = `${baseUrl}/allCount`;

	return await getData<ResponseDto<number>>(url, {
		params: {
			...params
		}
	});
}

export const getSYS4010_R01One = async (compCd: string) => {
	const url = `${baseUrl}/one/${compCd}`;
	
	return await getData<ResponseDto<SYS4010_R01Dto>>(url);
}

export const createSYS4010_R01 = async (data: SYS4010_R01Dto) => {
	return await postData<SYS4010_R01Dto, ResponseDto<SYS4010_R01Dto[]>>(baseUrl, data);
}

export const patchSYS4010_R01 = async (data: SYS4010_R01Dto) => {
	return await patchData<SYS4010_R01Dto, ResponseDto<SYS4010_R01Dto[]>>(baseUrl, data);
}

export const deleteSYS4010_R01 = async (compCd: string) => {

	return await deleteData<ResponseDto<any>>(baseUrl, {
		params: {
			primary: compCd
		}
	})
}

export const downloadExcel_SYS4010_R01 = async (option: string, params: Partial<SYS4010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`;

	return await getData<ResponseDto<string>>(url, {
		params: {
			...params,
			listLength
		}
	});
}